import React, { useRef, useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import parse from "html-react-parser";

export const htmlRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
) => {
    const quillRef = useRef(null);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (quillRef.current) {
            setIsLoaded(true);
        }
    }, [quillRef.current]);

    const handleChange = (content) => {
        if (content === "<p><br></p>") {
            content = "";
        }

        fieldUpdateHandler(name, content);
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image", "video"],
            ["clean"],
        ],
        clipboard: {
            matchVisual: false,
        },
    };

    const formats = [
        "header",
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "video",
    ];

    const loader = isLoaded ? null : <CircularProgress size={24} />;

    if (value == null || value == '<p><br></p>') {
        value = '';
    }

    return mutable || typeof fieldUpdateHandler === "function" ? (
        <>
            <ReactQuill
                ref={quillRef}
                value={value}
                onChange={handleChange}
                modules={modules}
                formats={formats}
                placeholder="Введите описание..."
                readOnly={!mutable}
            />
            {loader}
            {isError && (
                <div
                    style={{
                        color: "#f44336",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                        marginRight: "14px",
                        marginBottom: "0",
                        marginLeft: "14px",
                    }}
                >
                    {isError}
                </div>
            )}
        </>
    ) : (
        <div>{value ? parse(value) : "Nothing to show"}</div>
    );
};
